<div class="notification-success dissolve">
  <div class="event-item">
    <span class="notification-activity dismiss" [hidden]="time == null">{{time}}s</span>
    <div class="header-notification">
      <h3><span>Version Status Changed</span> - <em>#{{notification.data.id}}</em></h3>
    </div>
    <p>The status of the project has been successfully changed to {{notification.data.details.status ? notification.data.details.status : ''}}.</p>
  </div>
</div>